// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import dataTableStyles from "@awc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { productListStyles } from "@awc/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsProductList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

productListStyles.orderLinesList = {
    cardExpanded: {
        cartLineContainer: {
            container: {
                css: css`
                    grid-template-columns: 2fr 7fr 1fr 1fr 1fr;
                    ${xScreen("lte", "lg")} {
                        grid-template-columns: 2fr 7fr 1fr 1fr 1fr;
                    }
                    ${xScreen("lte", "md")} {
                        grid-template-columns: 1fr 5fr 2fr;
                        row-gap: 0;
                    }
                `,
            },
            image: {
                css: css`
                    display: flex;
                    justify-content: center;
                    ${xScreen("lte", "md")} {
                        grid-column: 1 / 2;
                        grid-row: 1 / 5;
                    }
                `,
            },
            description: {
                css: css`
                    grid-column: 2 / 3;
                    ${xScreen("lte", "sm")} {
                        grid-column: 2 / 4;
                        grid-row: 1 / 2;
                    }
                `,
            },
            price: {
                css: css`
                    grid-column: 2 / 3;
                    grid-row: 2 / 3;
                    ${xScreen("lte", "md")} {
                        grid-column: 2 / 3;
                        grid-row: 2 / 3;
                        text-align: right;
                    }
                    ${xScreen("lte", "sm")} {
                        grid-column: 2 / 4;
                        grid-row: 2 / 3;
                        text-align: left;
                    }
                `,
            },
            qty: {
                css: css`
                    grid-column: 4/5;
                    grid-row: 2/3;
                    text-align: left;
                    ${xScreen("lte", "md")} {
                        grid-column: 2 / 3;
                        grid-row: 2 / 3;
                        text-align: right;
                    }
                    ${xScreen("lte", "sm")} {
                        grid-column: 2 / 4;
                        grid-row: 3 / 4;
                        text-align: left;
                    }
                `,
            },
            total: {
                css: css`
                    grid-column: 5/6;
                    grid-row: 2/3;
                    ${xScreen("lte", "md")} {
                        grid-column: 3 / 4;
                        grid-row: 2 / 3;
                    }
                    ${xScreen("lte", "sm")} {
                        grid-column: 2/4;
                        grid-row: 4 / 5;
                    }
                `,
            },
            notes: {
                css: css`
                    grid-column: 2/3;
                    grid-row: 2/3;
                    ${xScreen("lte", "md")} {
                        grid-row: 3/4;
                    }
                    ${xScreen("lte", "sm")} {
                        grid-column: 1/4;
                        grid-row: 5/6;
                    }
                `,
            },
        },
        productImage: {
            ...mergeWithCss(cartLineSharedStyles.productImage, {
                linkWrappingImage: {
                    css: css`
                        ${xScreen("lte", "sm")} {
                            width: 114px;
                            height: 114px;
                        }
                    `,
                },
            }),
        },

        quantity: {
            qtyLabel: {
                color: "secondary",
                lineHeight: fontConfig.lineHeight.small,
            },
        },
        cartLineNotes: {
            readOnlyNotesText: {
                wrapper: {
                    css: css`
                        flex-direction: row;
                        align-items: baseline;
                        gap: 8px;
                        ${xScreen("lte", "sm")} {
                            margin-top: 5px;
                        }
                    `,
                },
                heading: {
                    color: "secondary",
                    size: fontConfig.fontSize.small,
                    weight: fontConfig.weight.bold,
                    lineHeight: fontConfig.lineHeight.singleLineSmall,
                    css: css`
                        text-transform: capitalize;
                        &:after {
                            content: ":";
                        }
                    `,
                },
                text: {
                    css: css`
                        width: auto;
                    `,
                },
            },
        },
    },
};

productListStyles.spinnerWrapper = {
    ...dataTableStyles.centeringWrapper,
};
